import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Report } from '../../models/report.model';

@Component({
  selector: 'app-informations-client',
  templateUrl: './informations-client.component.html',
  styleUrls: ['./informations-client.component.scss'],
})
export class InformationsClientComponent {
  @Input() informationsClient!: Report.Customer;
  @Input() isLoading = false;

  informationsClientInternal!: Report.Customer;

  @Output() informationsClientChanged = new EventEmitter<Report.Customer>();
  @Output() informationsClientEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  onInformationsClientChanged(
    informationsClientInternal: Report.Customer,
  ): void {
    this.informationsClientInternal = informationsClientInternal;
  }

  onSaveSection(): void {
    this.informationsClientChanged.emit(this.informationsClientInternal);
  }

  onEnabled(isEnabled: boolean): void {
    this.informationsClientEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.cancled.emit();
  }
}
